// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1V6jJ","buttons":"Footer_buttons__118x7"};